module.exports = __webpack_public_path__ + "img/dk.871fa60c.svg";